import {
	type AnyApiFactory,
	configApiRef,
	createApiFactory,
	type ApiRef,
	createApiRef,
	type OpenIdConnectApi,
	type ProfileInfoApi,
	type BackstageIdentityApi,
	type SessionApi,
	discoveryApiRef,
	oauthRequestApiRef
  } from '@backstage/core-plugin-api';
import { identityApiRef, analyticsApiRef } from '@backstage/core-plugin-api';
  import { OAuth2 } from '@backstage/core-app-api';
import {
	ScmAuth,
	ScmIntegrationsApi,
	scmIntegrationsApiRef,
} from "@backstage/integration-react";
import { techRadarApiRef } from "@backstage/plugin-tech-radar";
import { SegmentAnalytics } from "@janus-idp/backstage-plugin-analytics-provider-segment";
import {
	JanusBackstageCustomizeApiClient,
	janusBackstageCustomizeApiRef,
} from "./api";
import { ChatbotApiClient, chatbotApiRef } from "./api/chatbot-api";
import { CustomTechRadar } from "./lib/CustomTechRadar";

export const oidcAuthApiRef: ApiRef<
  OpenIdConnectApi & // The OICD API that will handle authentication
  ProfileInfoApi & // Profile API for requesting user profile info from the auth provider in question
  BackstageIdentityApi & // Backstage identity API to handle and associate the user profile with backstage identity.
  SessionApi // Session API, to handle the session the user will have while logged in.
> = createApiRef({
  id: 'auth.keycloak.oidc', // Updated to reflect Keycloak usage
});
export const apis: AnyApiFactory[] = [
	createApiFactory({
		api: oidcAuthApiRef,
		deps: {
		  discoveryApi: discoveryApiRef,
		  oauthRequestApi: oauthRequestApiRef,
		  configApi: configApiRef,
		},
		factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
		  OAuth2.create({
			discoveryApi,
			oauthRequestApi,
			configApi,
			provider: {
			  id: 'oidc',
			  title: 'Keycloak',
			  icon: () => null,
			},
			environment: configApi.getOptionalString('auth.environment'),
			defaultScopes: ['openid', 'profile', 'email'],
			popupOptions: {
			  size: {
				fullscreen: true,
				// or specify popup width and height
				//width: 1000,
				//height: 1000,
			  },
			},
		  }),
	  }),
	createApiFactory({
		api: scmIntegrationsApiRef,
		deps: { configApi: configApiRef },
		factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
	}),
	ScmAuth.createDefaultApiFactory(),
	createApiFactory({
	api: analyticsApiRef,
	deps: { configApi: configApiRef, identityApi: identityApiRef },
	factory: ({ configApi, identityApi }) =>
		SegmentAnalytics.fromConfig(configApi, identityApi),
}),
	createApiFactory({
		api: janusBackstageCustomizeApiRef,
		deps: {
			discoveryApi: discoveryApiRef,
			configApi: configApiRef,
		},
		factory: ({ discoveryApi, configApi }) =>
			new JanusBackstageCustomizeApiClient({ discoveryApi, configApi }),
	}),
	createApiFactory({
		api: techRadarApiRef,
		deps: {
			janusBackstageCustomizeApi: janusBackstageCustomizeApiRef,
		},
		factory: ({ janusBackstageCustomizeApi }) =>
			new CustomTechRadar({ janusBackstageCustomizeApi }),
	}),
	createApiFactory({
		api: chatbotApiRef,
		deps: { discoveryApi: discoveryApiRef },
		factory: ({ discoveryApi }) => new ChatbotApiClient({ discoveryApi }),
	}),
];
